var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParametre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.976,
    height: 22.976,
    viewBox: "0 0 22.976 22.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_63",
    "data-name": "Groupe 63",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_68",
    "data-name": "Trac\\xE9 68",
    d: "M14.534,7.531a2.009,2.009,0,0,1,3.9,0,2.014,2.014,0,0,0,3,1.247,2,2,0,0,1,2.756,2.756,2.014,2.014,0,0,0,1.247,3,2.009,2.009,0,0,1,0,3.9,2.014,2.014,0,0,0-1.247,3,2,2,0,0,1-2.756,2.756,2.014,2.014,0,0,0-3,1.247,2.009,2.009,0,0,1-3.9,0,2.014,2.014,0,0,0-3-1.247,2,2,0,0,1-2.756-2.756,2.014,2.014,0,0,0-1.247-3,2.009,2.009,0,0,1,0-3.9,2.014,2.014,0,0,0,1.247-3,2,2,0,0,1,2.756-2.756A2.014,2.014,0,0,0,14.534,7.531Z",
    transform: "translate(-5.998 -5.998)",
    fill: "none",
    stroke: "#53565a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_69",
    "data-name": "Trac\\xE9 69",
    d: "M26.389,22.194A4.194,4.194,0,1,1,22.194,18,4.2,4.2,0,0,1,26.389,22.194Z",
    transform: "translate(-11.707 -11.707)",
    fill: "none",
    stroke: "#53565a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParametre);
export default __webpack_public_path__ + "static/media/parametre.1f498f8ab95dc49c0eaad60befb045bc.svg";
export { ForwardRef as ReactComponent };